import { ReactComponent as FlagIcon } from "./svg/se-flag.svg";
import "../flag-icon.scss";

export const SEFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
